import React from 'react';
import { Box, Typography, Paper, Divider, Avatar } from '@mui/material';

const TeamNotificationsPreview = ({ notificationType, subject, message }) => {

    // Function to parse message and replace new lines with breaks
    const getFormattedMessage = (msg) => {
        if (!msg) return "";
        return msg.split('\n').map((item, key) => {
            return <span key={key}>{item}<br /></span>
        });
    };

    return (
        <Paper elevation={0} sx={{ p: 4, borderRadius: 2, backgroundColor: 'white', height: '100%' }}>
            <Box sx={{ mb: 4 }}>
                <Typography variant="h5" fontWeight="bold">
                    Preview
                </Typography>
            </Box>

            {/* Mobile Preview Container */}
            <Box sx={{
                border: '1px solid #e0e0e0',
                borderRadius: '16px',
                maxWidth: '375px', // Mobile width
                margin: '0 auto',
                overflow: 'hidden',
                backgroundColor: '#ffffff',
                boxShadow: '0 4px 12px rgba(0,0,0,0.1)',
                minHeight: '600px' // Ensure height for preview
            }}>
                {/* Header Bar */}
                <Box sx={{ backgroundColor: '#f5f5f5', p: 1.5, borderBottom: '1px solid #e0e0e0', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                    <Box sx={{ width: 40, height: 4, backgroundColor: '#d0d0d0', borderRadius: 2 }} />
                </Box>

                {/* Top Status Bar Mockup */}
                <Box sx={{ px: 2, py: 1, display: 'flex', justifyContent: 'space-between', borderBottom: '1px solid #f0f0f0' }}>
                    <Typography variant="caption" fontWeight="bold">9:41</Typography>
                    <Box sx={{ display: 'flex', gap: 0.5 }}>
                        <Box sx={{ width: 12, height: 12, borderRadius: '50%', border: '1px solid black' }} />
                        <Box sx={{ width: 12, height: 12, borderRadius: '50%', border: '1px solid black' }} />
                    </Box>
                </Box>


                {notificationType === 'email' ? (
                    // Email Preview
                    <Box>
                        {/* Email Header Fields */}
                        <Box sx={{ p: 2, borderBottom: '1px solid #f0f0f0' }}>
                            <Box sx={{ display: 'flex', mb: 1, alignItems: 'center' }}>
                                <Typography variant="caption" color="text.secondary" sx={{ width: 50 }}>From:</Typography>
                                <Typography variant="caption" fontWeight="bold">Touch Team</Typography>
                            </Box>
                            <Divider sx={{ my: 1 }} />
                            <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                <Typography variant="caption" color="text.secondary" sx={{ width: 50 }}>Subject:</Typography>
                                <Typography variant="caption" fontWeight="bold">{subject || 'Subject'}</Typography>
                            </Box>
                        </Box>

                        {/* Email Body */}
                        <Box sx={{ p: 3 }}>
                            <Typography variant="body2" sx={{ whiteSpace: 'pre-wrap', mb: 3, lineHeight: 1.6 }}>
                                {getFormattedMessage(message || 'Message content...')}
                            </Typography>
                        </Box>
                    </Box>
                ) : (
                    // Push Notification Preview
                    <Box sx={{
                        position: 'relative',
                        height: '500px',
                        backgroundImage: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)', // Simple background for lock screen look
                        p: 2
                    }}>
                        {/* Notification Card */}
                        <Paper sx={{
                            p: 2,
                            borderRadius: '12px',
                            backgroundColor: 'rgba(255, 255, 255, 0.9)',
                            backdropFilter: 'blur(4px)',
                            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                            maxWidth: '100%'
                        }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                <Avatar sx={{ width: 20, height: 20, bgcolor: 'black', mr: 1, fontSize: '10px' }}>T</Avatar>
                                <Typography variant="caption" fontWeight="bold" sx={{ flexGrow: 1 }}>TOUCH</Typography>
                                <Typography variant="caption" color="text.secondary">now</Typography>
                            </Box>
                            <Typography variant="subtitle2" fontWeight="bold" sx={{ mb: 0.5 }}>
                                {subject || 'Notification Title'}
                            </Typography>
                            <Typography variant="body2" fontSize="0.85rem">
                                {message || 'Notification message content appears here...'}
                            </Typography>
                        </Paper>
                    </Box>
                )}
            </Box>
        </Paper>
    );
};

export default TeamNotificationsPreview;
